<template>
    <section id="equipe">
        <h2 class="titulo">Equipe Sambamaníacos</h2>

        <div class="equipe container">
            <!-- <div > -->
                <cp-card-equipe
                    v-for="(profissional, index) in equipe"
                    :key="index"
                    :nome="profissional.nome"
                    :imagem="profissional.imagem"
                ></cp-card-equipe>

                <div class="card-empty empty-mobile"></div>
                <div class="card-empty"></div>
                <div class="card-empty"></div>
                <div class="card-empty"></div>
            <!-- </div> -->
        </div>
    </section>
</template>

<script>

import CpCardEquipe from '@/components/CardEquipe'

export default {
    components: {
        CpCardEquipe
    },
    data () {
        return {
            equipe: []
        }
    },
    created: function () {
        this.equipe = [
            {
                nome: 'Leo Fortes',
                imagem: 'https://assets.sambamaniacos.com.br/equipe/leo-fortes.jpg'
            },
            {
                nome: 'Robertinha',
                imagem: 'https://assets.sambamaniacos.com.br/equipe/robertinha.jpg'
            },
            {
                nome: 'Clarinha',
                imagem: 'https://assets.sambamaniacos.com.br/equipe/clarinha.jpg'
            },
            {
                nome: 'Pablo',
                imagem: 'https://assets.sambamaniacos.com.br/equipe/pablo.jpg'
            },
            {
                nome: 'Carol',
                imagem: 'https://assets.sambamaniacos.com.br/equipe/carol.jpg'
            },
            {
                nome: 'Márcio',
                imagem: 'https://assets.sambamaniacos.com.br/equipe/marcio.jpg'
            },
            {
                nome: 'Dieguinho',
                imagem: 'https://assets.sambamaniacos.com.br/equipe/dieguinho.jpg'
            },
            {
                nome: 'Rodrigo',
                imagem: 'https://assets.sambamaniacos.com.br/equipe/rodrigo.jpg'
            },
            {
                nome: 'Fernanda',
                imagem: 'https://assets.sambamaniacos.com.br/equipe/fernanda.jpg'
            },
            {
                nome: 'Jean',
                imagem: 'https://assets.sambamaniacos.com.br/equipe/jean.jpg'
            },
            {
                nome: 'Mylena',
                imagem: 'https://assets.sambamaniacos.com.br/equipe/mylena.jpg'
            },
            {
                nome: 'Vinícius',
                imagem: 'https://assets.sambamaniacos.com.br/equipe/vinicius.jpg'
            },
            {
                nome: 'Israel',
                imagem: 'https://assets.sambamaniacos.com.br/equipe/israel.jpg'
            },
            {
                nome: 'Lucy',
                imagem: 'https://assets.sambamaniacos.com.br/equipe/lucy.jpg'
            },
            {
                nome: 'Rapha',
                imagem: 'https://assets.sambamaniacos.com.br/equipe/rapha.jpg'
            },
            {
                nome: 'Leandrow',
                imagem: 'https://assets.sambamaniacos.com.br/equipe/leandrow.jpg'
            },
            {
                nome: 'Indyo',
                imagem: 'https://assets.sambamaniacos.com.br/equipe/indyo.jpg'
            },
            {
                nome: 'Felipe',
                imagem: 'https://assets.sambamaniacos.com.br/equipe/felipe.jpg'
            },
            {
                nome: 'Bellinha',
                imagem: 'https://assets.sambamaniacos.com.br/equipe/bellinha.jpg'
            }
        ]
    }
}
</script>

<style lang="sass" scoped>
    @import "../../../assets/sass/mixin"

    #equipe
        padding-top: 100px
        position: relative
        max-width: 100vw
        @include device(mobile)
            &
                padding-top: 50px
                padding-bottom: 80px
                overflow: hidden

        .titulo
            text-align: center
            margin-bottom: 50px
            @include device(mobile)
                &
                    padding: 0
        .equipe
            flex-wrap: wrap
            display: flex
            justify-content: center
            padding-bottom: 30px
            @include device(mobile)
                &
                    justify-content: flex-start
                    flex-wrap: inherit
                    overflow: scroll
                    padding-bottom: 0px
            .card-empty
                width: 200px
                height: 0px
                margin: 0 10px
                @include device(mobile)
                    &
                        display: none
                    &.empty-mobile
                        display: block
                        width: 10px
                        min-width: 10px
                        height: 1px

        .hand-animation
            z-index: 2
            margin-left: auto
            margin-right: auto
            display: none
            @include device(mobile)
                &
                    display: block
</style>
